/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper.ts';
import { v4 as uuidv4 } from 'uuid';
import * as Permission from '../util/Permission';
import { operationTypes } from './ChannelMappingDefType';

export default declareEntity({
    entity: 'scenarios2SourceDefs',
    graphQL: "Scenarios2SourceDef",
    name: "Scenario to Source Definition",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    dynamoPrefix: 'def',
    storageType: 'schema',
    parentRelation: "scenarios2SourceDefs",
    defaultOrder: ['channelDef_id', 'sourceDef_id'],
    onModify: ['scenarioDef'],
    fields: (types) => {
        return {
            id: {
                name: "Rule ID",
                type: "id",
                primaryKey: true,
                required: true,
                compositeKey: true,
                userEditable: false,
                defaultValue: () => {
                    return uuidv4();
                },
                isPublic: true,
            },
            scenario: {
                name: "Scenario",
                to: () => types['scenarios'],
                type: "relation",
                required: true,
                parent: true,
                compositeKey: true,
                hiddenCreate: true,
                defaultValue: (scenario) => {
                    return scenario['id'];
                },
                isPublic: true,
            },
            operation: {
                name: "Operation",
                type: "enum",
                values: operationTypes,
                isPublic: true,
            },
            channelDef: {
                name: "Application Definition",
                to: () => types['channelDefs'],
                type: "relation",
                required: true,
                isPublic: true,
            },
            channelEntityDef: {
                name: "Application Entity Definition",
                to: () => types['channelEntityDefs'],
                type: "relation",
                required: true,
            },
            sourceDef: {
                name: "Source Definition",
                to: () => types['sourceDefs'],
                type: "relation",
                required: true,
                isPublic: true,
                relativeTo: ['channelDef'],
            },
            scenarioDef: {
                name: "Scenario Definition",
                to: () => types['scenarioDefs'],
                type: "relation",
                required: true,
                isPublic: true,
            },
            screenDef: {
                name: "Scenario Screen Definition",
                to: () => types['scenarioScreenDefs'],
                type: "relation",
                relativeTo: ['scenarioDef'],
            },
        };
    }
});
